import React, { useEffect, useState } from "react";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { useNavigate } from "react-router-dom";

import Topbar from "../../../Component/Topbar/Topbar";
import { Table } from "../../../Component/Table/Table";
import { edit, search, view } from "../../../assets/img";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import DateRange from "../../../Component/DateRange/DateRange";
import SelectBox from "../../../Component/SelectBox";
import moment from "moment";
import { URLS } from "../../redux/api/Constants";
import { get, post } from "../../redux/api/ApiHandler";
const TechnicalTable = () => {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [superAdmin, setSuperAdmin] = useState();
  const [pagination, setPagination] = useState("");
  const [selected, setSelected] = useState(null);
  const [status, setStatus] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [regionOptions, setRegionOptions] = useState([]);
  const [fromDates, setFromDates] = useState(null);
  const [toDates, setToDates] = useState(null);

  const statusMap = {
    yet_to_start: { label: "Yet to Start", className: "yet_to_start_btn" },
    Issue_Completed: { label: "Issue Completed", className: "Issue_Completed" },
  };

  const ticketList = async (search, selected, fromDate, toDate) => {
    setSearchValue(search);
    setFromDates(fromDate);
    setToDates(toDate);

    let payload = {
      search: search,
      pagination: page,
      region_id: selected?.value,
      type: 2,
      // current_status: 6,
      from_date: fromDate ? moment(fromDate).format("DD-MM-YYYY") : "",
      to_date: toDate ? moment(toDate).format("DD-MM-YYYY") : "",
    };
    let res = await post(URLS.TICKET_LIST, payload)
    if (res?.status == "success") {
      let array = [6, 13];
      let arr = res?.lists.filter(item => array.includes(item?.current_status))

      // // 2️⃣ Handle current_status == 8 + last assigned_for == 2
      // res?.lists.forEach(item => {

      //   if (item.current_status === 8) {

      //     const latestMatch = [...item.ticket_details]
      //       .reverse()
      //       .find(i => i?.assigned_for === 2);

      //     if (latestMatch) {
      //       arr.push({
      //         ...item,
      //         last_assigned_detail: latestMatch   // merged detail
      //       });
      //     }
      //   }
      // });
      setList(arr);
      // setList(res?.lists);
      setPagination(res?.pagination_meta)
    }
  }




  const regionList = async () => {
    let res = await get(URLS.REGIONLIST);
    if (res?.status === "success" && Array.isArray(res?.roles)) {
      // 🔹 Convert API data to Select options
      const options = res?.roles.map((region) => ({
        value: region?.id,
        label: region?.name,
      }));
      setRegionOptions(options);

    }
  }

  useEffect(() => {
    ticketList()
    regionList()
  }, []);


  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{row.index + 1}</p>;
        },
      },

      {
        Header: "Regional Ticket ID",
        accessor: "code",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Region",
        accessor: "region",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Regional Manager",
        accessor: "regional_manager",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Service Engineer",
        accessor: "service_engineer",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Customer ID",
        accessor: "customer.code",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Customer Name",
        accessor: "customer",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value?.name}</p>;
        },
      },

      {
        Header: "Created By",
        accessor: "created_by",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value?.name}</p>;
        },
      },

      {
        Header: "Date",
        accessor: "opened_at",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{moment(value).format("DD-MM-YYYY")}</p>;
        },
      },
      // {
      //   Header: "Fault Type",
      //   accessor: "faulttype",
      //   Cell: ({ value, row }) => {
      //     return <p className="text-nowrap ">{value}</p>;
      //   },
      // },

      {
        Header: "Status",
        accessor: "current_status",
        Cell: ({ value, row }) => {
          // const { label, className } = statusMap[value] || {
          //   label: "Unknown",
          //   className: "default_btn",
          // };
          return (
            <div className="d-flex ac-jc">
              <button
                className={`${value == 6 ? "yet_to_start_btn" : value == 9 ? "dispatched_btn" : value == 10 ? "delivered_btn" : "dispatched_btn"} f1 fs-xs-12 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-16`}
              >
                {value == 6 ? "Technical" : value == 9 ? "Dispatched" : value == 10 ? "Delivered" : value == 13 ? "Issue Resolved" : "-"}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          const status = row.original.status;

          return (
            <div className="d-flex ac-jc mt-2 gap-3">
              <button
                onClick={() => {
                  navigate("/technical-view", { state: { type: "view", id: row?.original?.id } });
                }}
                className="cust-btn"
              >
                <img src={view} alt="View" className="editor-btn" />
              </button>

              {/* {status !== "Issue_Completed" && (
                <button
                  onClick={() => {
                    navigate("/technical-view", { state: { type: "edit", id: row?.original?.id } });
                  }}
                  className="cust-btn"
                >
                  <img src={edit} alt="Edit" className="editor-btn" />
                </button>
              )} */}
            </div>
          );
        },
      },
    ],
    []
  );
  return (
    <>
      <Topbar header={"Technical"} />
      <div className="container_fluit1">
        <div className="d-flex ac-jb">
          <h4 className="f3 fs-sm-15 fs-md-19 fs-lg-20 fs-xl-22 fs-xxl-24">
            Total User : {list?.length}
          </h4>
        </div>
        <div className="d-flex ac-je gap-4">
          <DateRange fromDate={fromDates} setFromDate={(val) => ticketList(searchValue, selected, val, toDates)}
            toDate={toDates}
            setToDate={(val) => ticketList(searchValue, selected, fromDates, val)} />

          <div className="col-md-2">
            <SelectBox options={regionOptions} selected={selected} setSelected={(val) => ticketList(searchValue, val)} />
          </div>

          <div className="search-input col-md-3 d-flex ac-jb my-4">
            <input value={searchValue} onChange={(e) => ticketList(e.target.value, selected)}
              type="text"
              placeholder="Search "
              className="search-field f2 fs-sm-13 fs-md-15 fs-lg-16 fs-xl-18 fs-xxl-20"
            />
            <img src={search} className="search" />
          </div>
        </div>
        <Table
          columns={columns}
          setPageno={setPage}
          pagecount={pagination}
          data={list}
          show={false}
        />
      </div>
    </>
  );
};

export default TechnicalTable;
